import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
// Create context with generic parameter
const ThemeContext = React.createContext(null);
// Generic Theme Provider component
export function ThemeProvider({ children, theme }) {
    const containerRef = React.useRef(null);
    React.useEffect(() => {
        const container = containerRef.current;
        const themeConfig = theme;
        if (!container)
            return;
        const updateTheme = () => {
            const setThemeProperties = (obj, prefix = '') => {
                Object.entries(obj).forEach(([key, value]) => {
                    if (typeof value === 'object' && value !== null) {
                        setThemeProperties(value, `${prefix}${key}-`);
                    }
                    else {
                        container.style.setProperty(`--${prefix}${key}`, String(value));
                    }
                });
            };
            setThemeProperties(themeConfig);
        };
        updateTheme();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [theme, containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]);
    return (_jsx(ThemeContext.Provider, { value: { theme, containerRef }, children: _jsx("div", { ref: containerRef, className: 'h-full w-full bg-containerBackground font-fontFamily', children: children }) }));
}
// Generic hook to use theme
export function useTheme() {
    const context = React.useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
